// extracted by mini-css-extract-plugin
module.exports = {"dp3-crowdfunding-bundle":"JP_dp3-crowdfunding-bundle__NApGV","loop":"JP_loop__o6dZc"};